import React from "react";
import { Route } from "react-router-dom";
import { UserRoleEnum } from "@/types/role.type";
import type { RouteCtx } from "../routeContext";
import { PlaceholderPage, NotFound } from "../shell";
import {
  PrincipalInvestigatorDashboard,
  SiteDashboard,
  RegulatoryApprovalsMain,
  ApprovalDetailPage,
  IssueRiskTrackerPage,
  CDAManagement,
  RBQMCenter,
} from "../lazyPages";

/** piRoutes — order preserved for React Router first-match. */
export function piRoutes(ctx: RouteCtx): React.ReactNode {
  const { userRole, hasRbqmAccess, currentStudy, onLogout } = ctx;

  if (userRole !== UserRoleEnum.PRINCIPAL_INVESTIGATOR) {
    return null;
  }

  return (
    <>
      <Route
        path="/pi/dashboard"
        element={
          <PrincipalInvestigatorDashboard
            onLogout={onLogout}
            userRole={userRole}
          />
        }
      />
      <Route
        path="/pi/ctms/dashboard"
        element={<PlaceholderPage title="CTMS Dashboard" />}
      />
      <Route
        path="/pi/ctms/study-overview"
        element={<PlaceholderPage title="Study Overview" />}
      />
      <Route
        path="/pi/ctms/site-dashboard"
        element={<SiteDashboard currentStudy={currentStudy} />}
      />
      <Route
        path="/pi/ctms/site-audit-trail"
        element={<PlaceholderPage title="Site Audit Trail" />}
      />
      <Route path="/studies" element={<PlaceholderPage title="My Studies" />} />
      <Route path="/subjects" element={<PlaceholderPage title="Subjects" />} />
      <Route path="/ecrfs" element={<PlaceholderPage title="eCRFs" />} />
      <Route
        path="/adverse-events"
        element={<PlaceholderPage title="Adverse Events" />}
      />
      <Route
        path="/documents"
        element={<PlaceholderPage title="Documents" />}
      />
      <Route
        path="/pi/regulatory"
        element={
          <RegulatoryApprovalsMain
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/pi/regulatory/:studyId/:id"
        element={<ApprovalDetailPage />}
      />
      <Route
        path="/pi/risk-tracker"
        element={
          <IssueRiskTrackerPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/pi/rbqm-center"
        element={
          hasRbqmAccess ? (
            <RBQMCenter userRole={userRole} currentStudy={currentStudy} />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/pi/cda-management"
        element={
          <CDAManagement userRole={userRole} currentStudy={currentStudy} />
        }
      />
    </>
  );
}
